module.exports = {
    orderManagement: {
        editDeliveryInfoPickUp: 'to collect my groceries from',
        editDeliveryInfoDelivery: 'my groceries delivered to',
        itemPickupFrom: 'Collect From:',
        itemHubSpok: 'Collect From:',
        noOrdersMessage: 'You currently have no open orders to display',
        notificationBannerTitle: 'You\'re currently changing your order',
        notificationBannerMessage: 'Please submit your changes at Checkout by {0}, or you\'ll receive your original order.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/order-management.js